<div>
  <img src="/assets/images/alert-warning.svg" alt="Warning icon" />
  <strong>{{ environmentName + " environment" | uppercase }}</strong>
</div>
